import { render, staticRenderFns } from "./UserTypeForm.vue?vue&type=template&id=4f808e80&"
import script from "./UserTypeForm.vue?vue&type=script&lang=js&"
export * from "./UserTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports